// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Projects {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.button-project {
  background-color: transparent;
  border: 2px solid black;
  border-radius: 20px;
  width: 80vw;
  height: 20vh;
  margin-top: 2vh;
  margin-bottom: 2vh;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.project-content {
  display: flex;
  align-items: center;
  flex-grow: 1;
}

.project-description {
  text-align: left;
  padding-left: 2vw;
  font-size: 18px;
  color: rgb(109, 91, 34);
}

.project-description p {
  margin-top: 1vh;
  padding: 0;
  font-size: 14px;
  color: #404447;
}

.project-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 10vw;
}

.project-divider {
  border-left: 1px solid black;
  height: 17vh;
  margin: 0 10px;
}


[data-theme='dark'] .project-description p {
  color: #cbcecf;
}

[data-theme='dark'] .project-description {
  color: rgb(45, 184, 154);
}

[data-theme='dark'] .button-project {
  border: 2px solid rgb(51, 50, 50);
}

[data-theme='dark'] .project-divider {
  border-left: 1px solid rgb(51, 50, 50);
}

@media (max-width: 1050px) {

  .project-description {
    font-size: 16px;
  }

  .project-description p {
    margin-top: 0.5vh;
    font-size: 12px;
    margin-right: 10px;
    width: 68vw;
  }

  .project-icon {
    width: 15vw;
  }

  .button-project {
    border-radius: 15px;
    width: 90vw;
    height: 22vh;
  }

  .project-divider {
    border-left: 1px solid black;
    height: 19vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Projects/Projects.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,cAAc;AAChB;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,4BAA4B;IAC5B,YAAY;EACd;AACF","sourcesContent":["#Projects {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n}\n\n.button-project {\n  background-color: transparent;\n  border: 2px solid black;\n  border-radius: 20px;\n  width: 80vw;\n  height: 20vh;\n  margin-top: 2vh;\n  margin-bottom: 2vh;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.project-content {\n  display: flex;\n  align-items: center;\n  flex-grow: 1;\n}\n\n.project-description {\n  text-align: left;\n  padding-left: 2vw;\n  font-size: 18px;\n  color: rgb(109, 91, 34);\n}\n\n.project-description p {\n  margin-top: 1vh;\n  padding: 0;\n  font-size: 14px;\n  color: #404447;\n}\n\n.project-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 10vw;\n}\n\n.project-divider {\n  border-left: 1px solid black;\n  height: 17vh;\n  margin: 0 10px;\n}\n\n\n[data-theme='dark'] .project-description p {\n  color: #cbcecf;\n}\n\n[data-theme='dark'] .project-description {\n  color: rgb(45, 184, 154);\n}\n\n[data-theme='dark'] .button-project {\n  border: 2px solid rgb(51, 50, 50);\n}\n\n[data-theme='dark'] .project-divider {\n  border-left: 1px solid rgb(51, 50, 50);\n}\n\n@media (max-width: 1050px) {\n\n  .project-description {\n    font-size: 16px;\n  }\n\n  .project-description p {\n    margin-top: 0.5vh;\n    font-size: 12px;\n    margin-right: 10px;\n    width: 68vw;\n  }\n\n  .project-icon {\n    width: 15vw;\n  }\n\n  .button-project {\n    border-radius: 15px;\n    width: 90vw;\n    height: 22vh;\n  }\n\n  .project-divider {\n    border-left: 1px solid black;\n    height: 19vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
